import React from "react";

const Kotlin_Home = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Home</h1>
      <p>Content for Kotlin Home goes here.</p>
    </div>
  );
};

export default Kotlin_Home;
